import React from 'react';
import Shiitake from 'shiitake';

export default (props) => <Shiitake {...props} />;
